<div class="modal"
     tabindex="-1"
     role="dialog"
     [ngStyle]="{'display':displayStyle}">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title"> Confirmation</h5>
      </div>
      <div class="modal-body">
        <p> Are you sure you want to delete : {{entityName}}</p>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-info"
                (click)="yes()">
          Yes
        </button>
        <button type="button" class="btn btn-info"
                (click)="no()">
          No
        </button>
      </div>
    </div>
  </div>
</div>
